module.exports = __webpack_public_path__ + "img/nextspin_spin_btn2.6e70d24e.png";